module.exports = __webpack_public_path__ + "static/img/5.74e5470.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/5.jpg
// module id = DAEz
// module chunks = 1